import Menu from '@shared/ui/Menu/Menu';
import MenuItem from '@shared/ui/Menu/MenuItem';
import { useAppSelector } from '@store/hooks.ts';
import { selectContentHeight } from '@store/reducers/appSlice.ts';
import classnames from 'classnames';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

const SideNavigation = () => {
  const { t } = useTranslation();
  const contentHeight = useAppSelector(selectContentHeight);
  const location = useLocation();
  const [showSideNav, setShowSideNav] = useState(true);

  useEffect(() => {
    const shouldShow = location.pathname.includes('admin');
    setShowSideNav(shouldShow);
  }, [location.pathname]);

  if (!showSideNav) return null;

  return (
    <nav
      className={classnames(
        'flex flex-col h-full overflow-hidden z-10 overflow-y-scroll overflow-x-hidden p-0',
      )}
      style={{ maxHeight: contentHeight, height: contentHeight }}
    >
      <section className="hidden lg:flex lg:flex-col lg:w-72 h-full mt-24">
        <Menu>
          <MenuItem
            link="/admin/dashboard"
            icon={
              <span className="flex p-1 rounded shadow-xs bg-gradient-to-br from-base-100/75 to-primary/10 ring-1 ring-primary/10">
                <div className="icon-[solar--graph-new-up-linear] text-primary h-5 w-5" />
              </span>
            }
          >
            {t('navigation.admin.dataCenter')}
          </MenuItem>

          <MenuItem
            link="/admin/user"
            icon={
              <span className="flex p-1 rounded shadow-xs bg-gradient-to-br from-base-100/75 to-primary/10 ring-1 ring-primary/10">
                <div className="icon-[solar--users-group-rounded-linear] text-primary h-5 w-5" />
              </span>
            }
          >
            {t('navigation.admin.users')}
          </MenuItem>

          <MenuItem
            link="/admin/content"
            icon={
              <span className="flex p-1 rounded shadow-xs bg-gradient-to-br from-base-100/75 to-primary/10 ring-1 ring-primary/10">
                <div className="icon-[solar--document-text-linear] text-primary h-5 w-5" />
              </span>
            }
          >
            {t('navigation.admin.content')}
          </MenuItem>

          <MenuItem
            link="/admin/question"
            icon={
              <span className="flex p-1 rounded shadow-xs bg-gradient-to-br from-base-100/75 to-primary/10 ring-1 ring-primary/10">
                <div className="icon-[solar--document-add-linear] text-primary h-5 w-5" />
              </span>
            }
          >
            {t('navigation.admin.questions')}
          </MenuItem>

          <hr className="w-full my-2 h-px border-0 bg-gradient-to-r from-primary/5 via-primary/20 to-primary/5"></hr>

          <MenuItem
            link="/admin/permission"
            icon={
              <span className="flex p-1 rounded shadow-xs bg-gradient-to-br from-base-100/75 to-primary/10 ring-1 ring-primary/10">
                <div className="icon-[solar--key-minimalistic-square-2-outline] text-primary h-5 w-5" />
              </span>
            }
          >
            {t('navigation.admin.permission')}
          </MenuItem>

          <MenuItem
            link="/admin/discussion"
            icon={
              <span className="flex p-1 rounded shadow-xs bg-gradient-to-br from-base-100/75 to-primary/10 ring-1 ring-primary/10">
                <div className="icon-[solar--square-academic-cap-outline] text-primary h-5 w-5" />
              </span>
            }
          >
            {t('navigation.admin.discussions')}
          </MenuItem>
        </Menu>
      </section>
    </nav>
  );
};

export default memo(SideNavigation);
